import { StockReport } from "./StockReport";
export default StockReport;
